// Function to map values from userData to sample create user payload by matching key names
export const mapValuesFromUserDatatoSamplePayload = (
  userDataPayload,
  SamplePayload,
  type = "full",
) => {
  const mapValues = (source, target) => {
    Object.keys(source).forEach((key) => {
      if (
        typeof source[key] === "object" &&
        !Array.isArray(source[key]) &&
        source[key] !== null
      ) {
        // If it's an object, recursively map values
        if (target[key]) {
          mapValues(source[key], target[key]);
        }
      } else if (Array.isArray(source[key])) {
        // If it's an array, map array values
        if (target[key]) {
          target[key] = source[key].map((item, index) => {
            if (typeof item === "object") {
              return { ...target[key][index], ...item };
            }
            return item;
          });
        }
      } else {
        // Directly copy values if the key exists in both objects
        if (target.hasOwnProperty(key)) {
          target[key] = source[key] ? source[key] : null;
        }
      }
    });
  };

  // Creating a deep copy of SamplePayload to avoid direct mutation
  const updatedSamplePayload = JSON.parse(JSON.stringify(SamplePayload));

  // Map values
  mapValues(userDataPayload, updatedSamplePayload);

  let finalPayload;
  if (type === "full") {
    finalPayload = {
      ...updatedSamplePayload,
      user_details: {
        ...updatedSamplePayload.user_details,
        full_name: [
          updatedSamplePayload.user_details?.first_name,
          updatedSamplePayload.user_details?.middle_name,
          updatedSamplePayload.user_details?.last_name,
        ]
          .filter(Boolean)
          .join(" "),
        education: updatedSamplePayload.user_details?.education?.length
          ? updatedSamplePayload.user_details?.education
          : null,
        job_history: updatedSamplePayload.user_details?.job_history?.length
          ? updatedSamplePayload.user_details?.job_history
          : null,
        misc: updatedSamplePayload.user_details?.misc?.length
          ? updatedSamplePayload.user_details?.misc
          : null,
      },
    };
  } else if (type === "edit") {
    finalPayload = {
      ...updatedSamplePayload,
      user_details: {
        ...updatedSamplePayload.user_details,
      },
      employee_id: updatedSamplePayload.user_details.employee_id,
    };
    // Delete specific keys from user_details
    const keysToDelete = [
      "first_name",
      "last_name",
      "middle_name",
      "employee_id",
      "address_country",
    ];
    keysToDelete.forEach((key) => {
      delete finalPayload.user_details[key];
    });
  } else {
    finalPayload = updatedSamplePayload;
  }

  return finalPayload;
};

// Function to convert userdetails response to add employee payload structure
export const convertResponseToPayload = (response, type) => {
  const updatedPayload = {};
  let obj = response[type];

  Object.keys(obj).forEach((key) => {
    if (obj[key]?.value !== undefined) {
      if (key === "full_name") {
        let splittedName = obj[key].value.trim().split(/\s+/);
        if (splittedName?.length > 2) {
          updatedPayload.first_name = splittedName[0];
          updatedPayload.middle_name = splittedName[1];
          updatedPayload.last_name = splittedName.slice(2).join(" ");
        } else {
          updatedPayload.first_name = splittedName[0];
          updatedPayload.last_name = splittedName[1];
        }
      } else {
        updatedPayload[key] =
          obj[key].value === "None" || obj[key].value === "N.A."
            ? ""
            : obj[key].value;
      }
    }
  });
  if (
    updatedPayload?.job_history === "" ||
    updatedPayload?.job_history === "[]" ||
    (Array.isArray(updatedPayload?.job_history) &&
      !updatedPayload.job_history.length)
  ) {
    updatedPayload.job_history = [];
  }
  if (
    updatedPayload?.education === "" ||
    updatedPayload?.education === "[]" ||
    (Array.isArray(updatedPayload?.education) &&
      !updatedPayload.education.length)
  ) {
    updatedPayload.education = [
      {
        university_name: null,
        educational_category: null,
        education_degree: null,
        field_of_specualisation: null,
        course_type: null,
        gpa: null,
        start_date: null,
        end_date: null,
      },
    ];
  }
  if (
    updatedPayload?.misc === "" ||
    updatedPayload?.misc === "[]" ||
    updatedPayload?.misc === "{}"
  ) {
    updatedPayload.misc = {};
  }
  return updatedPayload;
};

// convert draft response payload to userData structure
export const convertDraftResponseToPayload = (response, type) => {
  const updatedPayload = {};
  let obj = response[type];

  Object.keys(obj).forEach((key) => {
    if (obj[key] !== undefined) {
      if (key === "full_name") {
        let splittedName = obj[key]?.split(" ");
        if (splittedName?.length > 2) {
          updatedPayload.first_name = splittedName[0];
          updatedPayload.middle_name = splittedName[1];
          updatedPayload.last_name = splittedName[2];
        } else {
          updatedPayload.first_name = splittedName[0];
          updatedPayload.last_name = splittedName[1];
        }
      } else {
        updatedPayload[key] =
          obj[key] === "None" || obj[key].value === "N.A." ? "" : obj[key];
      }
    }
  });

  if (
    updatedPayload?.job_history === "" ||
    updatedPayload?.job_history === "[]" ||
    (Array.isArray(updatedPayload?.job_history) &&
      !updatedPayload.job_history.length)
  ) {
    updatedPayload.job_history = [];
  }
  if (
    updatedPayload?.education === "" ||
    updatedPayload?.education === "[]" ||
    (Array.isArray(updatedPayload?.education) &&
      !updatedPayload.education.length)
  ) {
    updatedPayload.education = [
      {
        university_name: null,
        educational_category: null,
        education_degree: null,
        field_of_specualisation: null,
        course_type: null,
        gpa: null,
        start_date: null,
        end_date: null,
      },
    ];
  }
  if (
    updatedPayload?.misc === "" ||
    updatedPayload?.misc === "[]" ||
    updatedPayload?.misc === "{}"
  ) {
    updatedPayload.misc = {};
  }
  return updatedPayload;
};

export const isEmpty = (value) => {
  if (Array.isArray(value)) {
    // Check if it's an empty array
    return value.length === 0;
  } else if (typeof value === "object" && value !== null) {
    // Check if it's an empty object
    return Object.keys(value).length === 0;
  }
  return false; // Not an array or object
};
